"use client"

export default function ElegantFooter() {
    return (
        <footer className="border-t border-primary/30 bg-background py-12">
            <div className="max-w-7xl mx-auto px-6">
                {/* Top Divider */}
                <div className="w-24 h-[2px] bg-primary mx-auto mb-8" />

                {/* Content */}
                <div className="text-center mb-8">
                    <h3 className="text-2xl font-serif font-light text-foreground mb-3">
                        Uma Experiência Gastronômica
                    </h3>
                    <p className="text-foreground/50 font-light tracking-wide text-sm">
                        Cada prato é preparado com dedicação e os melhores ingredientes
                    </p>
                </div>

                {/* Bottom Info */}
                <div className="flex flex-col items-center gap-3 pt-8 border-t border-primary/20">
                    <p className="text-foreground/40 text-sm font-light tracking-widest">
                        POWERED BY SYNCTECH
                    </p>
                    <div className="flex gap-6 text-xs text-foreground/30 font-light">
                        <span>© 2026</span>
                        <span>•</span>
                        <span>Todos os direitos reservados</span>
                    </div>
                </div>

                {/* Bottom Divider */}
                <div className="w-24 h-[2px] bg-primary mx-auto mt-8" />
            </div>
        </footer>
    )
}
